<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
      :checkbox-config="{
        highlight: true,
        reserve: true,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.shipmentStatus === 'D' || row.shipmentStatus === 'R'
              ? 'warning'
              : row.shipmentStatus === 'N'
              ? 'primary'
              : 'success'
          "
        >
          {{ row.v_shipmentStatus }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                openEditPage({
                  pageType: 'detail',
                  params: { code: row.shipmentCode },
                  query: { shipmentNo: row.shipmentNo },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                openEditPage({
                  pageType: 'edit',
                  params: { code: row.shipmentCode },
                  query: { shipmentNo: row.shipmentNo },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_export') || '导出'"
            placement="top"
            v-if="allow('E')"
          >
            <i
              class="el-icon-download tool-btn"
              @click="
                exportFile({
                  ...row,
                  templateGroup: 'shipment-polist',
                  exportCheckUrl: '/factory/shipmentBatch/checkData',
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('btn_shipment_plan_confirm') || '出货确认'"
            placement="top"
            v-if="allow('C')"
          >
            <i
              class="el-icon-circle-check tool-btn"
              @click="stuffingComplete(row)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_fallback') || '回退'"
            placement="top"
          >
            <i class="el-icon-refresh-left tool-btn" @click="rollback(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
    <ChooseTemplate
      :visible.sync="chooseTemplateOptions.visible"
      :templateQueryParams="{
        custCode: chooseTemplateOptions.custCode,
        endCustCode: chooseTemplateOptions.endCustCode,
        templateGroup: chooseTemplateOptions.templateGroup,
      }"
      :exportOptions="{
        params: { shipmentCode: chooseTemplateOptions.shipmentCode },
        checkUrl: chooseTemplateOptions.exportCheckUrl,
      }"
    />
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
import ChooseTemplate from '@/views/factory/transport/components/choose-template'
export default {
  mixins: [TableAutoHeight, EditLoading],
  components: { ChooseTemplate },
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
      chooseTemplateOptions: {
        visible: false,
        shipmentCode: '',
        custCode: '',
        endCustCode: '',
        templateGroup: '',
        exportCheckUrl: '',
      },
    }
  },
  methods: {
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'order-shipmentPlanConfirm-detail',
        params: { ...params, pageType },
        query,
      })
    },
    rollback({ shipmentCode, shipmentNo, shipmentStatus }) {
      this.$confirm(
        '确认要回退出货计划【' + shipmentNo + '】吗？',
        '确认信息',
        {
          type: 'warning',
        }
      ).then(() => {
        this.loadingOpen()
        this.$api
          .shipmentInfoBackApi({
            shipmentCode,
            shipmentStatus,
          })
          .then((res) => {
            this.loadingClose()
            const { status } = res
            if (status === 200) {
              this.$message({
                showClose: true,
                message: res.msg,
                type: 'success',
              })
              this.$emit('reload')
            } else {
              this.$message.error(res.msg)
            }
          })
          .catch(() => {
            this.loadingClose()
          })
      })
    },
    exportFile({
      shipmentCode,
      custCode,
      endCustCode,
      templateGroup,
      exportCheckUrl,
    }) {
      this.chooseTemplateOptions = {
        visible: true,
        shipmentCode,
        custCode,
        endCustCode,
        templateGroup,
        exportCheckUrl,
      }
    },

    stuffingComplete({ shipmentCode, shipmentNo }) {
      this.$confirm(
        `${'是否确认发运完成？'}【${shipmentNo}】`,
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          type: 'warning',
        }
      ).then(() => {
        this.loadingOpen()
        this.$api
          .shipmentDraftCompletedApi({ shipmentCode })
          .then((res) => {
            this.loadingClose()
            const { status, msg: message } = res

            if (status === 200) {
              this.$message({
                showClose: true,
                message:
                  // this.$l('tips_stuffing_complete_ok') ||
                  '确认发运，操作成功！',
                type: 'success',
              })
              this.$emit('reload')
              return
            }

            if (status === 203) {
              this.$message({
                dangerouslyUseHTMLString: true,
                message,
                type: 'error',
                duration: 5000,
                showClose: true,
                customClass: 'stuffing-message',
              })
              return
            }
            this.$message.error(
              this.$l('tips_stuffing_complete_no') || '确认装柜，操作失败！'
            )
          })
          .catch(() => {
            this.loadingClose()
          })
      })
    },
  },
}
</script>
<style lang="scss">
.stuffing-message {
  p.el-message__content {
    > p {
      line-height: 28px;
      strong {
        margin-left: 4px;
      }
    }
  }
}
</style>
